import { assoc } from 'ramda'

const fromLatLngAndLevel = (latLng, levelId) => assoc('levelId', levelId, latLng)

export { fromLatLngAndLevel }

